import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import { UIText1 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { ProgressBar } from '../ProgressBar';

export interface IRatingDetailProps {
  name: string;
  fillingPercentage: number;
  score: string;
}

export const RatingDetail: React.FC<IRatingDetailProps> = props => {
  const { name, fillingPercentage, score } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['label']}>
        <UIHeading4>{name}</UIHeading4>
      </div>
      <div className={styles['bar']}>
        <ProgressBar fillingPercentage={fillingPercentage} />
      </div>
      <div className={styles['rating']}>
        <UIText1>{score}</UIText1>
      </div>
    </div>
  );
};
